export default __webpack_public_path__ + "static/media/ListHeader.1c3fe06b.jfif";